/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form/dist/types";
import { useTranslation } from "react-i18next";
import { Label } from "semantic-ui-react";
import styles from "./LandingPage/LandingForm/LandingForm.module.css";

interface ValidationInput {
  errors: FieldErrors<FieldValues>;
  name: string;
  pointing?: "left" | "right" | "above" | "below";
  internal?: boolean;
}

const ValidationError: React.FC<ValidationInput> = ({
  errors,
  name,
  pointing,
  internal,
}) => {
  if (!errors[name]) {
    return null;
  }

  const { t } = useTranslation("common");

  const messages: { [key: string]: { [key: string]: string } } = {
    username: {
      pattern: t("valid_work_email"),
    },
    email: {
      pattern: t("valid_work_email"),
    },
    password: {
      required: t("password_required"),
      pattern: t("valid_password"),
    },
    code: {
      pattern: t("digit_code_required"),
    },
  };

  // When input error defines error message, use that. If there are none,
  // lookup default message based on the name of the field and type of the
  // validation error. Hide label if no error message is found.
  const error = errors[name];
  const message =
    error && error.message
      ? error.message
      : error && messages[name] && messages[name][error.type]
      ? messages[name][error.type]
      : "";

  return message ? (
    <div
      className={
        internal
          ? styles.landingFormValidationContainerInternal
          : styles.landingFormValidationContainer
      }
    >
      <Label
        prompt
        pointing={pointing}
        {...(!internal && { color: "red" })}
        {...(internal && { className: styles.internalValidatorLabel })}
      >
        {message}
      </Label>
    </div>
  ) : null;
};

export default ValidationError;
